 const allProjects = [
  // ==========================================
  // FEATURED / CURRENT PROJECTS
  // ==========================================

  {
    id: 1,
    imgSrc: "/codeaegis/1.png",
    heading: "CodeAegis",
    detail:
      "A modern technology company website focused on innovative digital solutions and IT services.",
    BtnText: "View Case Study",
    src: "/portfolio-details/1",
    liveUrl: "https://codeaegis.com",
    category: "featured",
    delay: "100",
  },

  {
    id: 2,
    imgSrc: "/smartcarrots/1.png",
    heading: "SmartCarrots",
    detail:
      "A modern referral and lead management platform connecting businesses, partners, and connectors.",
    BtnText: "View Case Study",
    src: "/portfolio-details/2",
    liveUrl: "https://dev.smartcarrots.com/",
    category: "featured",
    delay: "200",
  },

  // ==========================================
  // SELECTED LIVE PROJECTS
  // ==========================================

  {
    id: 5,
    imgSrc: "/plushland/Screenshot1.png",
    heading: "Plushland",
    detail: "High-quality and customized stuffed animals.",
    BtnText: "View Project",
    src: "/portfolio-details/5",
    category: "featured",
    delay: "500",
  },

  {
    id: 6,
    imgSrc: "/grocio.png",
    heading: "Grocio",
    detail: "A modern online grocery shopping platform.",
    BtnText: "View Project",
    src: "/portfolio-details/6",
    category: "featured",
    delay: "600",
  },

  {
    id: 7,
    imgSrc: "/vrcd/Screenshot1.png",
    heading: "VR Club Direct",
    detail: "Business development and market research solutions.",
    BtnText: "View Project",
    src: "/portfolio-details/7",
    category: "live",
    delay: "700",
  },

  {
    id: 8,
    imgSrc: "/mybagclub.png",
    heading: "My Bag Club",
    detail: "An online platform for exploring bags and fashion products.",
    BtnText: "View Project",
    src: "/portfolio-details/8",
    category: "featured",
    delay: "800",
  },

  {
    id: 9,
    imgSrc: "/Waje Technologies/Screenshot1.png",
    heading: "Waje Technologies",
    detail: "Broad-spectrum technology solutions and digital services.",
    BtnText: "View Project",
    src: "/portfolio-details/9",
    category: "live",
    delay: "900",
  },

  {
    id: 10,
    imgSrc: "/Devine Attire/Screenshot1.png",
    heading: "Devine Attire",
    detail: "A fashion platform focused on elegance and style.",
    BtnText: "View Project",
    src: "/portfolio-details/10",
    category: "live",
    delay: "1000",
  },

  {
    id: 11,
    imgSrc: "/JERAH BEAUTY/Screenshot1.png",
    heading: "Jerah Beauty",
    detail: "A modern beauty and salon platform.",
    BtnText: "View Project",
    src: "/portfolio-details/11",
    category: "featured",
    delay: "1100",
  },

  {
    id: 12,
    imgSrc: "/Eterna Private Dept/Screenshot1.png",
    heading: "Eterna Private Dept",
    detail: "Private financial and wealth management services.",
    BtnText: "View Project",
    src: "/portfolio-details/12",
    category: "live",
    delay: "1200",
  },

  {
    id: 13,
    imgSrc: "/Insignia Spaces/Screenshot1.png",
    heading: "Insignia Spaces",
    detail: "Construction, refurbishment, and fit-out solutions.",
    BtnText: "View Project",
    src: "/portfolio-details/13",
    category: "live",
    delay: "1300",
  },

  {
    id: 14,
    imgSrc: "/Hensen Window Systems/Screenshot1.png",
    heading: "Hensen Window Systems",
    detail: "Specialized window systems and construction solutions.",
    BtnText: "View Project",
    src: "/portfolio-details/14",
    category: "live",
    delay: "1400",
  },

  {
    id: 3,
    imgSrc: "/lbw11/1.png",
    heading: "LBW11",
    detail:
      "A responsive digital sports and fantasy platform designed for an engaging user experience.",
    BtnText: "View Case Study",
    src: "/portfolio-details/3",
    liveUrl: "https://lbw11.com/",
    delay: "300",
  },

  {
    id: 4,
    imgSrc: "/bnea/1.png",
    heading: "BNEA News App",
    detail:
      "A digital news application project created for the Bahamas National Exam Agency.",
    BtnText: "View Case Study",
    src: "/portfolio-details/4",
    liveUrl: "https://codeaegis.com/case-study/bnea-news-app",
    delay: "400",
  },
  {
    id: 15,
    imgSrc: "/Send & Care/Screenshot1.png",
    heading: "Send & Care",
    detail: "A secure blockchain-focused healthcare platform.",
    BtnText: "View Project",
    src: "/portfolio-details/15",
    category: "live",
    delay: "1500",
  },

  {
    id: 16,
    imgSrc: "/Eterna/Screenshot1.png",
    heading: "Eterna Groupe Financier",
    detail: "A financial services group with a legacy of excellence.",
    BtnText: "View Project",
    src: "/portfolio-details/16",
    category: "live",
    delay: "1600",
  },

  {
    id: 17,
    imgSrc: "/LTY/Screenshot1.png",
    heading: "LTY",
    detail: "A digital insurance broker focused on simplifying coverage.",
    BtnText: "View Project",
    src: "/portfolio-details/17",
    category: "live",
    delay: "1700",
  },

  {
    id: 18,
    imgSrc: "/Filli/Screenshot1.png",
    heading: "Filli",
    detail: "A digital experience for the Golden-Spiced Tea brand.",
    BtnText: "View Project",
    src: "/portfolio-details/18",
    category: "live",
    delay: "1800",
  },

  {
    id: 19,
    imgSrc: "/idigitalweb/Screenshot1.png",
    heading: "iDigital Web",
    detail: "A digital agency focused on transforming ideas into reality.",
    BtnText: "View Project",
    src: "/portfolio-details/19",
    category: "live",
    delay: "1900",
  },

  {
    id: 20,
    imgSrc: "/Swiftspend/Screenshot1.png",
    heading: "Swiftspend",
    detail: "A fast and simple digital money transfer platform.",
    BtnText: "View Project",
    src: "/portfolio-details/20",
    category: "live",
    delay: "2000",
  },
];

export default allProjects;